import { render, staticRenderFns } from "./BaseAlertType.vue?vue&type=template&id=3c3e9c8a&"
import script from "./BaseAlertType.vue?vue&type=script&lang=js&"
export * from "./BaseAlertType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports